<template>
  <span v-if="stepper" class="rcp-step" :class="{ 'is-changed': edited }">
    <button type="button" :aria-label="$t('recipes_shell.fewer', { shift })" :disabled="current <= 0" @click="emitValue(current - 1)">
      <v-icon size="16">mdi-minus</v-icon>
    </button>
    <input
      ref="input"
      v-model="raw"
      type="text"
      inputmode="numeric"
      autocomplete="off"
      data-portion
      :aria-label="label"
      :title="title"
      @input="onInput"
      @blur="settle"
      @keydown="onKey"
    />
    <button type="button" :aria-label="$t('recipes_shell.more', { shift })" @click="emitValue(current + 1)">
      <v-icon size="16">mdi-plus</v-icon>
    </button>
  </span>
  <input
    v-else
    ref="input"
    v-model="raw"
    class="rcp-in"
    :class="{ 'is-changed': edited }"
    type="text"
    inputmode="numeric"
    autocomplete="off"
    data-portion
    :aria-label="label"
    :title="title"
    @input="onInput"
    @blur="settle"
    @keydown="onKey"
  />
</template>

<script>
import { count } from "../recipesLogic";

/**
 * Polje "Porcije" jednog jela u jednoj smjeni: cijeli broj od 0 (slova se ne prihvataju, prazno je 0).
 * Strelice gore/dolje mijenjaju za 1, sa Shift za 10, Enter prelazi na sljedeće polje. Dok se kuca, polje drži
 * ono što je upisano (prazno polje se može popuniti iznova), a na izlasku pokazuje stvarni broj.
 * `stepper` dodaje dugmad − i + (telefon).
 */
export default {
  name: "PortionField",
  props: {
    value: { type: Number, required: true },
    edited: { type: Boolean, default: false },
    shift: { type: Number, default: 0 },
    label: { type: String, default: "" },
    title: { type: String, default: "" },
    stepper: { type: Boolean, default: false },
  },
  data() {
    return { raw: String(this.value) };
  },
  computed: {
    current() {
      return count(this.raw.replace(",", "."));
    },
  },
  watch: {
    value(next) {
      if (this.current !== next) {
        this.raw = String(next);
      }
    },
  },
  methods: {
    onInput() {
      // samo cifre, tačka, zarez i minus; sve ostalo (slova) se odmah briše iz polja
      const cleaned = this.raw.replace(/[^\d.,-]/g, "");
      if (cleaned !== this.raw) {
        this.raw = cleaned;
      }
      this.$emit("input", this.current);
    },
    emitValue(next) {
      const value = count(next);
      this.raw = String(value);
      this.$emit("input", value);
    },
    settle() {
      this.raw = String(this.value);
    },
    focusAndSelect(el) {
      if (el) {
        el.focus();
        el.select();
      }
    },
    onKey(event) {
      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        event.preventDefault();
        this.emitValue(this.current + (event.key === "ArrowUp" ? 1 : -1) * (event.shiftKey ? 10 : 1));
        this.$nextTick(() => this.focusAndSelect(this.$refs.input));
      } else if (event.key === "Enter") {
        event.preventDefault();
        const fields = [...document.querySelectorAll("input[data-portion]")];
        const at = fields.indexOf(this.$refs.input);
        this.settle();
        this.$nextTick(() => this.focusAndSelect(fields[at + 1]));
      }
    },
  },
};
</script>
